module.exports = __webpack_public_path__ + "img/table_baoxiaofeiyong.feaf95cb.png";